export function enhanceEpiForms() {
    // grabs only nested text nodes
    function textNodesUnder(el) {
        var n, a = [], walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
        while (n = walk.nextNode()) a.push(n);
        return a;
    }

    let containers = Array.prototype.slice.call(document.querySelectorAll('.EPiServerForms'));

    containers.forEach(container => {
        let newWrapper = document.createElement('div');
        newWrapper.className = 'epi-form';
        container.parentNode.insertBefore(newWrapper, container);
        newWrapper.appendChild(container);

        let formChoiceLabels = Array.prototype.slice.call(container.querySelectorAll('.FormChoice:not(.FormChoice--Image) > label'));
        let formID = container.id || (Math.ceil(Math.random() * 1000));

        formChoiceLabels.forEach((fieldLabel, index) => {
            let fieldInput = fieldLabel.querySelector('input');
            let fieldName = `input-${formID}-${index}`;
            fieldLabel.parentNode.insertBefore(fieldInput, fieldLabel);
            fieldLabel.setAttribute('for', fieldName);
            fieldInput.id = fieldName;
        });
    });

    let formChoiceImageLabels = Array.prototype.slice.call(document.querySelectorAll('.EPiServerForms .FormChoice--Image > label'));

    formChoiceImageLabels.forEach(fieldLabel => {
        fieldLabel.classList.add('enhanced-fields');
    });

    let captchaRefreshBtn = document.querySelector('.FormCaptcha__Refresh');

    if (captchaRefreshBtn) { 
        // Originally set to type="submit" which caused user
        // experience issues 
        captchaRefreshBtn.setAttribute('type', 'button');
    }

    let formTextboxLabels = Array.prototype.slice.call(document.querySelectorAll('.EPiServerForms .FormTextbox > label'));

    formTextboxLabels.forEach(formLabel => {
        if (formLabel.innerHTML.toLowerCase().indexOf('phone') > -1) {

            let formInputField = formLabel.parentElement.querySelector('input[type="text"]');

            if (formInputField != null) {
                formInputField.addEventListener('input', function (e) {
                    let input = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                    e.target.value = !input[2] ? input[1] : '(' + input[1] + ') ' + input[2] + (input[3] ? '-' + input[3] : '');
                });
            }
        }
    })
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/epi-forms.ts